import styled from 'styled-components';

export const SelectedDatasource = styled.div`
  align-items: center;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  padding: 7px 8px;
  justify-content: space-between;
  height: 45px;

  span {
    color: #061e2d;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 350px;

    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
  }

  svg {
    margin-left: 2px;
  }
`;

export const DatasourceList = styled.div`
  --border-radius: 4px;

  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: var(--border-radius);
  box-shadow: 0 9px 13px 7px rgba(0, 0, 0, 0.2);
  max-height: 370px;
  width: 100%;
  display: block;
  position: relative;
`;

export const PublicDatasourceDropdownWrapper = styled.div`
  padding-right: 20px;
  padding-left: 16px;
  margin-bottom: 30px;
  position: relative;
  z-index: 5;
`;
